<template>
    <div class="fd-detail-main">
        <div class="fd-voice-bg" v-if="spdz && spdz!==''">
            <video :src="spdz" controls="controls" autoplay="autoplay"></video>
        </div>
    </div>
</template>

<script>
export default {
    name: 'index',
    data() {
        return {
            navList: [],
            // 视频地址，视频封面
            spdz: ''
        };
    },
    mounted() {
        this.initData();
    },
    methods: {
        initData() {
            this.spdz = this.$route.query.src;
        }
    }
};
</script>

<style lang="less" scoped>

.fd-voice-bg {
    margin: 0 auto 44px;
    padding: 55px 0;
    width: 768px;
    height: 512px;
    background-color: #000;

    video {
        width: 100%;
        height: 100%;
    }
}

.fd-xgfj-title {
    margin-top: 45px;
    padding-left: 23px;
    color: #000;
    font-size: 16px;
    line-height: 26px;
    letter-spacing: 1px;
    background: url(~@/images/common/icon-file.png) left center no-repeat;
}

.fd-xgfj-list {
    margin-top: 8px;
    margin-left: 23px;
    color: #0053b4;
    font-size: 16px;
    line-height: 21px;
    cursor: pointer;
}
</style>
